import triggerAnnotationRender from './triggerAnnotationRender';
export function triggerAnnotationRenderForViewportIds(renderingEngine, viewportIdsToRender) {
    if (!viewportIdsToRender.length) {
        return;
    }
    viewportIdsToRender.forEach((viewportId) => {
        const viewport = renderingEngine.getViewport(viewportId);
        triggerAnnotationRender(viewport?.element);
    });
}
export default triggerAnnotationRenderForViewportIds;
//# sourceMappingURL=triggerAnnotationRenderForViewportIds.js.map